export interface CategoryGroupType {
  handle: string
  i18nKey: string
  description: Record<string, string>
}

/**
 * @deprecated Legacy category store – no longer fetches data.
 * All consumers should migrate to `useCategoryTreeStore`.
 * Kept as a stub so existing imports don't break during migration.
 */
export const useCategoryGroup = defineStore('category-group', () => {
  const categoryGroup = computed<CategoryGroupType[]>(() => [])
  const categories = computed<CategoryGroupType[]>(() => [])
  const subCategories = computed<CategoryGroupType[]>(() => [])
  const allCategoriesByGroup = computed<Record<string, CategoryGroupType[]>>(() => ({}))

  const isCategoryGroupsPending = computed(() => false)
  const isCategoriesPending = computed(() => false)
  const isSubCategoriesPending = computed(() => false)

  const categoryGroupsError = ref(null)
  const categoriesFetchError = ref<Error | null>(null)
  const subCategoriesError = ref(null)

  function getCategoryGroups() {}
  async function getCategories(_handle: string): Promise<CategoryGroupType[]> {
    return []
  }
  function getSubCategories(_handle: string) {}
  async function fetchAllCategories(): Promise<void> {}
  async function fetchCategoriesForGroup(_handle: string): Promise<CategoryGroupType[]> {
    return []
  }
  function setCurrentCategoriesHandle(_handle: string) {}
  function refreshCategoryGroups() {}
  function refreshSubCategories() {}
  function $reset() {}

  return {
    categoryGroup,
    categories,
    subCategories,
    allCategoriesByGroup,

    isCategoryGroupsPending,
    isCategoriesPending,
    isSubCategoriesPending,

    categoryGroupsError,
    categoriesFetchError,
    subCategoriesError,

    getCategoryGroups,
    getCategories,
    getSubCategories,
    fetchAllCategories,
    fetchCategoriesForGroup,
    setCurrentCategoriesHandle,
    refreshCategoryGroups,
    refreshSubCategories,
    $reset,
  }
})
